// extracted by mini-css-extract-plugin
export var dropdownContainer = "_o1-0";
export var leftAlign = "_o1-4";
export var listItem = "_o1-2";
export var listItemWrapper = "_o1-1";
export var operationText = "_o1-3";